import axios from "axios";
import { apiEndpoint } from '@iso/lib/helpers/endpoint';
import { authHeader } from '@iso/lib/helpers/authHeader';
import { isSuccess } from '@iso/lib/helpers/apiResponse';

/**
 * Shared user-location contract, the same one the mobile apps use.
 */
export const locationService = {
  getList,
  reportMine,
  getSharing,
  setSharing
};

/**
 * Everyone on the property with the position they are sharing. Members who
 * turned sharing off come back with null coordinates and
 * `sharing_enabled: false`, so the roster can show them as "(User Disabled)"
 * rather than dropping them.
 */
function getList(propertyId){
  return (
    axios
      .get(
        `${apiEndpoint.location}`,
        {
          headers: authHeader(),
          params: { property_id: propertyId }
        }
      ).then(res => {
        if(res && res.status === 200 && isSuccess(res.data)){
          return res.data;
        }
      })
  );
}


/**
 * Report the signed-in user's own position from the browser.
 *
 * Sent as source 'web', which is the only source the sharing toggle governs —
 * a mobile report carries its own consent and is never gated by it. The server
 * rejects this outright when the user has sharing switched off, so the toggle
 * is enforced in one place rather than trusted to the client.
 */
function reportMine(propertyId, { latitude, longitude, accuracyMeters, recordedAt }){
  return (
    axios
      .post(
        `${apiEndpoint.location}`,
        {
          property_id: propertyId,
          latitude,
          longitude,
          accuracy_meters: accuracyMeters,
          recorded_at: recordedAt,
          source: 'web'
        },
        {
          headers: authHeader()
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
      })
  );
}

/** The signed-in user's sharing preference on this property. */
function getSharing(propertyId){
  return (
    axios
      .get(
        `${apiEndpoint.locationSharing}`,
        {
          headers: authHeader(),
          params: { property_id: propertyId }
        }
      ).then(res => {
        if(res && res.status === 200 && isSuccess(res.data)){
          return res.data;
        }
      })
  );
}

/**
 * Turn the signed-in user's own sharing on or off. Switching off also makes
 * the server forget the stored position, so nothing can surface it later.
 */
function setSharing(propertyId, sharingEnabled){
  return (
    axios
      .patch(
        `${apiEndpoint.locationSharing}`,
        { property_id: propertyId, sharing_enabled: sharingEnabled },
        {
          headers: authHeader()
        }
      ).then(res => {
        if(res && res.status === 200){
          return res.data;
        }
      })
  );
}
